import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import CountryView from 'chairisher/view/account/countries';

import { getBusinessType } from 'chairisher/context/business';
import { AmplitudeEventProperty, logScreenView, TrackingScreen } from 'chairisher/util/analytics';

/**
 * Controller that binds actions for the pros registration page
 */
class BusinessEnrollController extends BaseController {
    /** @inheritDoc * */
    bindPageAnalytics() {
        super.bindPageAnalytics();
        logScreenView(TrackingScreen.BUSINESS_REGISTER, {
            [AmplitudeEventProperty.BUSINESS_TYPE]: getBusinessType(),
        });
    }

    /** @inheritDoc * */
    bindPageActions() {
        super.bindPageActions();

        const $form = $('.js-salesforce-web-to-lead-form');
        const $requiredFields = $('.js-required-field');
        const $errorFields = $('.js-errors');

        $form.on('submit', (e) => {
            e.preventDefault();

            let shouldSubmit = true;

            $errorFields.toggleClass('transparent', true);

            $requiredFields.each((i) => {
                const $requiredField = $requiredFields.eq(i);
                const requiredFieldValue = $requiredField.val() ?? '';

                if (requiredFieldValue.trim() === '') {
                    $requiredField.siblings('.js-errors').toggleClass('transparent', false);
                    shouldSubmit = false;
                }
            });
            if ($('.g-recaptcha-response').val() === '') {
                $('.g-recaptcha').siblings('.js-errors').toggleClass('transparent', false);
                shouldSubmit = false;
            }

            if (shouldSubmit) {
                $form[0].submit();
            }
        });

        const countryView = new CountryView({ $countryEl: $('.js-address-country') });
        countryView.bind();
    }
}

export default BusinessEnrollController;
